import { Box, Flex, Image, Stack, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { GalleriesLandingInterface } from "../../constants/Landing";
import useScreenWidth from "../../lib/useScreenWidth";
import { useBgHover } from "../../themes/colors";
import { CardSkeleton } from "../skeleton/CardSkeleton";
import { capitalizeFirstLetter } from "../../utils/helperFunction";

const BusinessRolesExplained = ({
  roleList,
  isRoleListDataLoading,
}: {
  roleList: GalleriesLandingInterface[] | undefined;
  isRoleListDataLoading: boolean;
}) => {
  const [selectedRole, setSelectedRole] = useState<GalleriesLandingInterface>();
  const bgHover = useBgHover();
  const sw = useScreenWidth();

  useEffect(() => {
    if (roleList) {
      setSelectedRole(roleList[0]);
    }
  }, [roleList]);

  const clickedImage = () => {
    if (selectedRole?.content) {
      window.open(selectedRole?.content, "_blank");
    }
  };

  return (
    <Flex
      w={"100%"}
      gap={sw > 1280 ? 4 : 8}
      flexDir={sw > 1280 ? "row" : "column"}
    >
      <VStack
        flex={sw > 1280 ? 2 : 1}
        my={"auto"}
        align={"stretch"}
        textAlign={sw > 1280 ? "start" : "center"}
      >
        <Text textStyle={"h-title"}>
          Pelajari lebih lanjut mengenai{" "}
          <Text as="span" color="red.400">
            BisnisLink
          </Text>
        </Text>

        <Text textStyle={"h-subtitle"} variant={"secondary"}>
          {selectedRole?.description}
        </Text>
      </VStack>

      {isRoleListDataLoading ? (
        <CardSkeleton row={1} height={264} />
      ) : (
        <Box
          w={"100%"}
          maxW={sw > 1280 ? "560px" : "800px"}
          my={"auto"}
          mx={"auto"}
          onClick={clickedImage}
          cursor={"pointer"}
        >
          <Image
            className="ratio-16-9"
            w={"100%"}
            objectFit={"cover"}
            src={
              selectedRole?.video_thumbnail
                ? `${process.env.REACT_APP_MEDIA_URL}${selectedRole?.video_thumbnail}`
                : ""
            }
            fallbackSrc="/assets/svg/illustration_empty.svg"
            alt={selectedRole?.title || ""}
            borderRadius={"xl"}
          />
        </Box>
      )}

      {isRoleListDataLoading ? (
        <CardSkeleton row={3} height={40} />
      ) : (
        <Stack
          w={"100%"}
          mx={"auto"}
          flex={1}
          mt={[2, null, null, null, 0]}
          justify={"space-evenly"}
          flexDir={sw > 1280 ? "column" : "row"}
        >
          {roleList?.map((role, index) => (
            <VStack
              key={index}
              w={sw > 1280 ? "fit-content" : "100%"}
              cursor="pointer"
              py={2}
              px={[8, null, null, null, 4]}
              borderRadius={"md"}
              align={sw > 1280 ? "stretch" : "center"}
              transition={"all 0.3s ease-in-out"}
              _hover={{ bg: bgHover }}
              onClick={() => {
                setSelectedRole(role);
              }}
              borderLeft={
                sw > 1280
                  ? `solid 4px ${
                      role?.id === selectedRole?.id ? "red" : "transparent"
                    }`
                  : undefined
              }
              borderBottom={
                sw > 1280
                  ? undefined
                  : `solid 4px ${
                      role?.id === selectedRole?.id ? "red" : "transparent"
                    }`
              }
            >
              <Text textStyle={"h-reg-title"}>
                {capitalizeFirstLetter(role?.title)}
              </Text>
            </VStack>
          ))}
        </Stack>
      )}
    </Flex>
  );
};

export default BusinessRolesExplained;
